import { Company } from "@app/interface/company";
import { OldSideMenu } from "./old-mekanic-menu";
import { roles } from "@app/shared/lists/roles";

export const OLD_TCAR_INTEGRATED_MENU: (company: Company) => OldSideMenu[] = (company) => {

  const menus = [
    {
      component: 'company',
      href: ['/company'],
      icon: 'domain',
    },
    {
      component: 'budgets',
      profileModule: "OS",
      blockedRoles: [roles.mechanic.id],
      icon: 'assignment',
      shadows: ['budget-create'],
      childs: [
        {
          component: 'budget',
          shadows: ['budget_detail', 'ro_create'],
          profileRule: "OS.list.budget",
          href: ['company', company.id, 'os', 'budget']
        },
        {
          component: 'rejected',
          shadows: ['rejected_detail'],
          profileRule: "OS.list.rejectedBudget",
          href: ['company', company.id, 'os', 'rejected']
        },
      ]
    },
    {
      component: 'ro',
      blockedRoles: [roles.mechanic.id],
      profileModule: "OS",
      icon: 'assignment_turned_in',
      shadows: ['ro-create'],
      childs: [
        {
          component: 'integrated_opened',
          shadows: ['opened_detail'],
          profileRule: "OS.list.integratedOpen",
          href: ['company', company.id, 'os', 'integrated_opened']
        },
        {
          profileModule: "OS",     // finalizadas
          component: 'finished',
          shadows: ['ended_detail'],
          profileRule: "OS.list.endedRo",
          href: ['company', company.id, 'os', 'ended']
        },

      ]
    },
      {
          component: 'clients',
          profileModule: "CLIENT",
          blockedRoles: [roles.mechanic.id],
          isTopLevel: true,
          icon: 'assignment_ind',
          href: ['company', company.id, 'clients'],
          shadows: ['client-detail']
      },
    {
      component: 'users',
      profileModule: "USER",
      blockedRoles: [roles.mechanic.id, roles.consultant.id],
      icon: 'people',
      childs: [
        {
          profileRule: "USER.REGISTERED_USERS.read",
          component: 'user-list',
          href: ['company', company.id, 'users'],
          shadows: ['user-detail'],
        },
        {
          profileRule: "USER.ACCESS_CONTROL.read",
          component: 'access-profile',
          href: ['company', company.id, 'access-profile'],
          shadows: ['access-profile-edit']
        }
      ]
    },
    {
      component: 'parts',
      profileModule: "PART",
      blockedRoles: [roles.mechanic.id],
      icon: 'settings',
      childs: [
        {
          component: 'parts-consult',
          href: ['company', company.id, 'parts-consult'],
          profileRule: "PART.partsConsult"
        }
      ]
    },
    {
      component: 'records',
      blockedRoles: [roles.mechanic.id, roles.consultant.id],
      profileModule: "RECORDS",
      icon: 'note_add',
      childs: [
        {
          component: 'checklist',
          profileRule: "RECORDS.mkgChecklist.read",
          href: ['company', company.id, 'records', 'checklist']
        },
        {
          component: 'checklist-models',
          profileRule: "RECORDS.checklistByModel.read",
          href: ['company', company.id, 'records', 'checklist-model']
        },
      ]
    }
  ];
  return menus
}
